import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Badge from "@mui/material/Badge";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { isDefinedString } from "et3-type-guards";
import { fontWeights } from "et3-ui-library";
import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabat101MatchStore from "../../../../../stores/khattabat-stores/101m-stores";
import getKhattabat101MMessagingStore from "../../../../../stores/khattabat-stores/101m-stores/101m-messaging-store";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";
import getKhattabatSharedMessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import getKhattabatSelectsStore from "../../../../../stores/khattabat-stores/selects-store";
import KhattabatMessages from "../../../khattabat-clients/conversation/body/messages/KhattabatMessages";
import KhattabatMatchActions from "./KhattabatMatchActions";

const KhattabatMatchConversation = withLiteObserverAndTheme<{
  matchID: number;
}>((props) => {
  const { matchID } = props;
  const {
    conversationID,
    matchUserName,
    isSilentBanned,
    matchStatus,
    matchStatusColor,
    matchConvesationIsDisabled,
    matchConversationIsHighlighted,
    matchHasDeletedTheConversation,
    matchResidence,
    matchNationality,
    matchAge,
    matchHeight,
    matchWeight,
    matchLastLogin,
    marriageType
  } = getKhattabat101MatchStore(matchID);
  const { isOpened, unreadMessagesCounter } = getKhattabatSharedMessagingStore(
    conversationID.get()
  );
  const { isMarkedConversation, toggleMarkConversation } =
    getKhattabatSelectsStore();
  const clientID = getKhattabat101MGeneralStore().clientID.get();
  const isMarked = isMarkedConversation(matchID);
  const userLink = `/users/advanced?id=${matchID}`;

  return (
    <Accordion
      expanded={isOpened.get() === "OPENED"}
      onChange={() =>
        getKhattabat101MMessagingStore(matchID).toggleConversationOpenState()
      }
      variant="outlined"
      disableGutters
      slotProps={{ transition: { unmountOnExit: true } }}
      sx={{
        borderRadius: 3,
        borderColor: isMarked ? "success.main" : "divider",
        "&:before": { display: "none" }
      }}
    >
      <AccordionSummary
        expandIcon={
          <Badge color="error" badgeContent={unreadMessagesCounter.get()}>
            {isOpened.get() === "OPENED" ? (
              <ExpandLessIcon />
            ) : (
              <ExpandMoreIcon />
            )}
          </Badge>
        }
        sx={{
          "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "none"
          }
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
          sx={{ pr: 1 }}
        >
          <Checkbox
            color="success"
            checked={isMarked}
            onClick={(event) => event.stopPropagation()}
            onFocus={(event) => event.stopPropagation()}
            onChange={() => toggleMarkConversation({ userID: matchID })}
            slotProps={{ input: { "aria-label": matchUserName.get() } }}
          />
          <Link
            href={userLink}
            target="_blank"
            underline="hover"
            fontWeight={fontWeights.semibold}
            onClick={(event) => event.stopPropagation()}
          >
            {matchUserName.get()}
          </Link>
          {isSilentBanned.get() === 1 ? (
            <Chip
              size="small"
              color="error"
              label={i18n.get("SILENT_BAN_ABBREVIATION")}
            />
          ) : null}
          <Link
            href={userLink}
            target="_blank"
            underline="hover"
            color="text.secondary"
            onClick={(event) => event.stopPropagation()}
          >
            {matchID}
          </Link>
          <Chip
            size="small"
            variant="outlined"
            color={matchStatusColor.get()}
            label={matchStatus.get()}
          />
          {matchConvesationIsDisabled.get() ? (
            <Chip size="small" label={i18n.get("KHATTABAT_101M_DISABLED")} />
          ) : null}
          {matchConversationIsHighlighted.get() ? (
            <Chip
              size="small"
              color="warning"
              variant="outlined"
              label={i18n.get("KHATTABAT_101M_HIGHLIGHTED")}
            />
          ) : null}
          {matchHasDeletedTheConversation.get() ? (
            <Chip
              size="small"
              color="error"
              variant="outlined"
              label={i18n.get("DELETED_BY_MATCH")}
            />
          ) : null}
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("KHATTABAT_CLIENT_LOCATION")}: ${matchResidence.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("NATIONALITY")}: ${matchNationality.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("AGE")}: ${matchAge.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("HEIGHT")}: ${matchHeight.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("WEIGHT")}: ${matchWeight.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("LAST_LOGIN")}: ${matchLastLogin.get()}`}
          />
          {isDefinedString(marriageType.get()) ? (
            <Chip size="small" variant="outlined" label={marriageType.get()} />
          ) : null}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={2}>
          <KhattabatMatchActions matchID={matchID} />
          <KhattabatMessages
            conversationID={conversationID.get()}
            userID={clientID}
          />
          <Typography fontWeight={fontWeights.semibold} color="error.main">
            {i18n.get("COMMENTS")}
          </Typography>
          <KhattabatMessages
            conversationID={`${conversationID.get()}_COMMENTS`}
            userID={clientID}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
});

export default KhattabatMatchConversation;
